module.exports = __webpack_public_path__ + "img/ic_bed_heat1.6d851b74.png";